import React, { Component } from 'react';
import {Link} from 'react-router';

export default class Footer extends Component {

    render() {
        return (
            <footer className="footer footer-four">
                <div className="primary-footer brand-bg text-center">
                    <div className="container">
                        <a href="#top" className="page-scroll btn-floating btn-large pink back-top waves-effect waves-light" data-section="#top">
                            <i className="material-icons">&#xE316;</i>
                        </a>
                        <ul className="social-link tt-animate ltr mt-20">
                            <li>
                                <a target="_blank" rel="noopener noreferrer" href="http://facebook.com.br/fcsistema.com.br">
                                    <i className="fa fa-facebook"></i>
                                </a>
                            </li>
                            <li>
                                <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/FC_Sistema">
                                    <i className="fa fa-twitter"></i>
                                </a>
                            </li>
                            {/* <li>
                                <a href="#">
                                    <i className="fa fa-tumblr"></i>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-linkedin"></i>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-dribbble"></i>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-instagram"></i>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="fa fa-rss"></i>
                                </a>
                            </li> */}
                        </ul>
                        <hr className="mt-10" />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="footer-logo">
                                    <img src="/assets/img/logo-white.png" alt="" />
                                </div>
                                <span className="copy-text">Copyright &copy; 2017   <a href="/">FC Sistemas</a> &nbsp; | &nbsp; All Rights Reserved &nbsp;</span>
                                {/* <div className="footer-intro">
                                    <p>Penatibus tristique velit vestibulum adipiscing habitant aenean feugiat at condimentum aptent
                         odio orci vulputate hac mollis a.Vestibulum adipiscing gravida justo a ac euismod vitae.</p>
                                </div> */}
                            </div>
                            {/* <!-- /.col-md-12 --> */}
                        </div>
                        {/* <!-- /.row --> */}
                    </div>
                    {/* <!-- /.container --> */}
                </div>
                {/* <!-- /.primary-footer --> */}
                <div className="secondary-footer brand-bg darken-2 text-center">
                    <div className="container">
                        <ul>
                            <li>
                                <Link to="/">Home</Link>
                            </li>
                            <li>
                                <Link to="/about">Sobre Nós</Link>
                            </li>
                            <li>
                                <Link to="/services">Serviços</Link>
                            </li>
                            <li>
                                <Link to="/clients">Clientes</Link>
                            </li>
                            <li>
                                <Link to="/blog">Blog</Link>
                            </li>
                            <li>
                                <Link to="/contact">Contato</Link>
                            </li>
                        </ul>
                    </div>
                    {/* <!-- /.container --> */}
                </div>
                {/* {  /.secondary-footer --> */}
            </footer>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js